import { create } from 'zustand'
import type { OmoteAvatarRef } from '@omote/r3f'

interface AvatarStore {
  avatarRef: OmoteAvatarRef | null
  setAvatarRef: (ref: OmoteAvatarRef | null) => void
}

export const useAvatarStore = create<AvatarStore>((set) => ({
  avatarRef: null,
  setAvatarRef: (ref) => set({ avatarRef: ref }),
}))
